export default __webpack_public_path__ + "static/media/Trend5.fd949483.svg";